/**
 * Единые фазы и наборы DS-снимка (WUI-344 §3, §6; WUI-314 бейдж ленты).
 */
export type DsAttachmentPhase =
  | 'none'
  | 'idle'
  | 'editing'
  | 'downloading'
  | 'awaiting_ws'
  | 'staged'
  | 'error'
  | 'discarded'

/** Фазы ожидания DS — спиннер на карточке ленты. `editing` (правки в открытом Р7) — не busy. */
export const DS_ATTACHMENT_BUSY_PHASES: ReadonlySet<DsAttachmentPhase> = new Set([
  'downloading',
  'awaiting_ws',
])

/**
 * Блок open/view/preview в Р7 и клик по карточке Office-строки.
 * `editing` — бейдж без спиннера; open/лента кликабельны.
 * Блокируют: `awaiting_ws` / `downloading` / error.
 */
export const DS_ATTACHMENT_OPEN_BLOCKED_PHASES: ReadonlySet<DsAttachmentPhase> = new Set([
  'downloading',
  'awaiting_ws',
  'error',
  'discarded',
])

export function isDsAttachmentBusyPhase(phase: DsAttachmentPhase): boolean {
  return DS_ATTACHMENT_BUSY_PHASES.has(phase)
}

export function isDsAttachmentOpenBlockedPhase(phase: DsAttachmentPhase): boolean {
  return DS_ATTACHMENT_OPEN_BLOCKED_PHASES.has(phase)
}

/** Для store: `none` — снимка нет, open не блокируем. */
export function isDsAttachmentRowOpenBlocked(phase: DsAttachmentPhase): boolean {
  return phase !== 'none' && isDsAttachmentOpenBlockedPhase(phase)
}
